export default __webpack_public_path__ + "static/media/last.37e32c07.svg";